module.exports = __webpack_public_path__ + "static/media/computerMockup.3dd7c47f.png";